import React from "react";
import { Alert, Container } from "@mui/material";
import { hasRoleOrGroup } from "./access";

/**
 * Envolve uma tela/rota e só renderiza o conteúdo se o usuário logado tiver
 * pelo menos uma das roles em `allow` — ou estiver num grupo de mesmo nome
 * no Keycloak (ver auth/access.js: grupo "/dev" vale o mesmo que a role
 * "dev"). Caso contrário, mostra um aviso de acesso restrito no lugar.
 *
 * Uso:
 *   <RequireRole allow={[ROLES.ADMIN]}>
 *     <MinhaTela />
 *   </RequireRole>
 *
 * Para liberar uma tela nova para mais perfis, basta listar as roles em
 * `allow`, por exemplo: allow={[ROLES.ADMIN, ROLES.DEV]}
 */
export default function RequireRole({ allow = [], children }) {
  const permitido = allow.length === 0 || allow.some((role) => hasRoleOrGroup(role));

  if (!permitido) {
    return (
      <Container maxWidth="sm" style={{ marginTop: 64 }}>
        <Alert severity="warning">
          Você não tem permissão para acessar esta área. Se acha que isso é um
          engano, fale com um administrador do sistema.
        </Alert>
      </Container>
    );
  }

  return children;
}
